import { getRedirectUriQueryParam } from '../../../../utils/url';

export const DEFAULT_REFERRER = '/jobs';

export function getReferrer(): string {
  return getRedirectUriQueryParam() ?? DEFAULT_REFERRER;
}
